import { LevelsSummaryModel } from '~/types/math-vault'

export function activityPassedUpdatedLevelsSummary(
  levelsSummary: LevelsSummaryModel,
  currentLevel: number,
  currentActivityNumber: number,
  numberOfActivities: number,
): LevelsSummaryModel {
  const levelInfo = levelsSummary[currentLevel]

  if (!levelInfo) {
    return {
      ...levelsSummary,
      [currentLevel]: {
        noOfQuestionsPassed: 1,
        questionsAnsweredCorrectly: [currentActivityNumber],
        levelNumber: String(currentLevel),
        noOfQuestionsTried: 1,
        questionsAnsweredWrong: [],
        isCompleted: false,
      },
    }
  } else {
    let correctQuestions = levelsSummary[currentLevel].questionsAnsweredCorrectly
    const isAlreadyAnsweredCorrectly = correctQuestions.includes(currentActivityNumber)

    if (!isAlreadyAnsweredCorrectly) {
      correctQuestions = [...correctQuestions, currentActivityNumber]

      const noOfQuestionsPassed = levelsSummary[currentLevel].noOfQuestionsPassed + 1
      const questionTried = levelsSummary[currentLevel].noOfQuestionsTried
      const noOfQuestionsTried = questionTried < numberOfActivities ? questionTried + 1 : questionTried

      return {
        ...levelsSummary,
        [currentLevel]: {
          ...levelsSummary[currentLevel],
          noOfQuestionsPassed,
          noOfQuestionsTried,
          questionsAnsweredCorrectly: correctQuestions,
        },
      }
    }
  }
  return levelsSummary
}

export function activityFailedUpdatedLevelsSummary(
  levelsSummary: LevelsSummaryModel,
  currentLevel: number,
  currentActivityNumber: number,
  numberOfActivities: number,
  alreadyPassed: boolean,
): LevelsSummaryModel {
  const levelInfo = levelsSummary[currentLevel]
  if (!levelInfo) {
    return {
      ...levelsSummary,
      [currentLevel]: {
        noOfQuestionsPassed: 0,
        questionsAnsweredCorrectly: [],
        levelNumber: String(currentLevel),
        noOfQuestionsTried: 1,
        questionsAnsweredWrong: [currentActivityNumber],
        isCompleted: false,
      },
    }
  } else {
    let wrongQuestions = levelsSummary[currentLevel].questionsAnsweredWrong
    const isAlreadyAnsweredWrong = wrongQuestions.includes(currentActivityNumber)

    if (!isAlreadyAnsweredWrong && !alreadyPassed) {
      wrongQuestions = [...wrongQuestions, currentActivityNumber]

      const questionTried = levelsSummary[currentLevel].noOfQuestionsTried
      const noOfQuestionsTried = questionTried < numberOfActivities ? questionTried + 1 : questionTried

      return {
        ...levelsSummary,
        [currentLevel]: {
          ...levelsSummary[currentLevel],
          noOfQuestionsTried,
          questionsAnsweredWrong: wrongQuestions,
        },
      }
    }
  }

  return levelsSummary
}
